import React, { useState, useEffect } from 'react';
import { supabase } from '../auth';

const Icons = {
    Home: () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-brand-500"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
    ),
    UserPlus: () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="8.5" cy="7" r="4" /><line x1="20" y1="8" x2="20" y2="14" /><line x1="23" y1="11" x2="17" y2="11" /></svg>
    ),
    Loader: () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="animate-spin"><path d="M21 12a9 9 0 1 1-6.219-8.56" /></svg>
    )
};

export default function InviteAcceptance({ inviteCode }) {
    const [isAccepting, setIsAccepting] = useState(false);
    const [status, setStatus] = useState('idle'); // idle, loading, success, error
    const [message, setMessage] = useState('');
    const [user, setUser] = useState(null);

    useEffect(() => {
        const checkUser = async () => {
            const { data: { user } } = await supabase.auth.getUser();
            setUser(user);
        };
        checkUser();
    }, []);

    const handleAccept = async () => {
        if (!user) {
            // Redirect to login with return URL
            const returnUrl = encodeURIComponent(`/invite/#invite=${inviteCode}`);
            window.location.href = `/login/?returnTo=${returnUrl}`;
            return;
        }

        setIsAccepting(true);
        try {
            const { data, error } = await supabase.functions.invoke('household-ops', {
                method: 'POST',
                body: { action: 'accept_invite', code: inviteCode }
            });

            if (error) throw error;

            if (data.success) {
                setStatus('success');
                setMessage(data.message);
                setTimeout(() => {
                    window.location.href = '/profile/';
                }, 2000);
            } else {
                setStatus('error');
                setMessage(data.error || 'Failed to join household');
            }
        } catch (error) {
            console.error('Accept invite error:', error);
            setStatus('error');
            setMessage('An unexpected error occurred');
        } finally {
            setIsAccepting(false);
        }
    };

    if (status === 'success') {
        return (
            <div className="bg-green-50 border border-green-200 text-green-700 px-6 py-4 rounded-lg text-center">
                <h3 className="font-bold text-lg mb-2">Success!</h3>
                <p>{message}</p>
                <p className="text-sm mt-2">Redirecting to your profile...</p>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6">
            <h3 className="text-xl font-bold flex items-center gap-2 mb-4">
                <Icons.Home />
                Join Household
            </h3>

            <p className="text-gray-600 mb-6">
                You've been invited to join a household. By accepting, you'll gain access to shared membership benefits.
            </p>

            {status === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm mb-4">
                    {message}
                </div>
            )}

            <button
                onClick={handleAccept}
                disabled={isAccepting}
                className="btn btn-primary w-full flex items-center justify-center gap-2"
            >
                {isAccepting ? (
                    <>
                        <Icons.Loader /> Processing...
                    </>
                ) : (
                    <>
                        <Icons.UserPlus /> Accept Invitation
                    </>
                )}
            </button>

            {!user && (
                <p className="text-xs text-center text-gray-500 mt-2">
                    You will be asked to log in or sign up.
                </p>
            )}
        </div>
    );
}
